import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { AppProvider, useApp } from './contexts/AppContext';
import { MemberLayout } from './components/member/MemberLayout';
import { AdminLayout } from './components/admin/AdminLayout';
import { Login } from './pages/Login';
import { MemberHome } from './pages/member/Home';
import { MemberEvents } from './pages/member/Events';
import { MemberEventDetail } from './pages/member/EventDetail';
import { MemberLongAbsence } from './pages/member/LongAbsence';
import { MemberAttendance } from './pages/member/Attendance';
import { MemberAnnouncements } from './pages/member/Announcements';
import { MemberAnnouncementDetail } from './pages/member/AnnouncementDetail';
import { MemberMaterials } from './pages/member/Materials';
import { MemberProfile } from './pages/member/Profile';
import { AdminDashboard } from './pages/admin/Dashboard';
import { AdminMembers } from './pages/admin/Members';
import { AdminMemberDetail } from './pages/admin/MemberDetail';
import { AdminEvents } from './pages/admin/Events';
import { AdminEventDetail } from './pages/admin/EventDetail';
import { AdminEventForm } from './pages/admin/EventForm';
import { AdminAttendanceIndex } from './pages/admin/AttendanceIndex';
import { AdminAttendanceTake } from './pages/admin/AttendanceTake';
import { AdminAttendanceReport } from './pages/admin/AttendanceReport';
import { AdminFees } from './pages/admin/Fees';
import { AdminAnnouncements } from './pages/admin/Announcements';
import { AdminAnnouncementForm } from './pages/admin/AnnouncementForm';
import { AdminAnnouncementReads } from './pages/admin/AnnouncementReads';
import { AdminMaterials } from './pages/admin/Materials';
import { AdminCalendar } from './pages/admin/Calendar';
import { AdminSettings } from './pages/admin/Settings';
import { DEMO_ADMIN, DEMO_CLAN, DEMO_GOST } from './data/members';
type ZacetniPogled = 'prijava' | 'clan' | 'gost' | 'vodstvo';
function Zascita({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    role
  } = useApp();
  if (!role) return <Navigate to="/" replace data-id="element-0" data-mp="3ud1gzdqblwcq" />;
  return <>{children}</>;
}
function ZacetnaNastavitev({
  pogled
}: {
  pogled: ZacetniPogled;
}) {
  const {
    login
  } = useApp();
  const navigate = useNavigate();
  useEffect(() => {
    if (pogled === 'clan') {
      login('clan', DEMO_CLAN);
      navigate('/clan', {
        replace: true
      });
    } else if (pogled === 'gost') {
      login('gost', DEMO_GOST);
      navigate('/clan', {
        replace: true
      });
    } else if (pogled === 'vodstvo') {
      login('vodstvo', DEMO_ADMIN);
      navigate('/admin', {
        replace: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
interface AppProps {
  /** Kateri pogled se odpre ob zagonu prototipa. */
  zacetniPogled?: ZacetniPogled;
}
export function App({
  zacetniPogled = 'prijava'
}: AppProps) {
  return <AppProvider data-id="element-1" data-mp="2swbq75gnb0i1">
      <BrowserRouter data-id="element-2" data-mp="2suqv9eqf5fjn">
        <ZacetnaNastavitev pogled={zacetniPogled} data-id="element-3" data-mp="2svjwk06lzcue" />
        <Routes data-id="element-4" data-mp="18d9d06h7bks6">
          <Route path="/" element={<Login data-id="element-6" data-mp="18cgflw44u7mp" />} data-id="element-5" data-mp="18cq5zkt3agsx" />

          <Route path="/clan" element={<Zascita data-id="element-8" data-mp="1d62iwxoeoz5u">
                <MemberLayout data-id="element-9" data-mp="1d6kk88pxe3km" />
              </Zascita>} data-id="element-7" data-mp="18by8g4fxm900">
            <Route index element={<MemberHome data-id="element-11" data-mp="ydqvdworkb3a" />} data-id="element-10" data-mp="yh6agziftk4p" />
            <Route path="dogodki" element={<MemberEvents data-id="element-13" data-mp="13fg8rizgl0uj" />} data-id="element-12" data-mp="13e54zj60jt3f" />
            <Route path="dogodki/:id" element={<MemberEventDetail data-id="element-15" data-mp="1r3r466mdy8bf" />} data-id="element-14" data-mp="13clr1z7txu4t" />
            <Route path="odsotnost" element={<MemberLongAbsence data-id="element-17" data-mp="1r2g1690rl4ld" />} data-id="element-16" data-mp="1r5k8vgdfuigs" />
            <Route path="prisotnost" element={<MemberAttendance data-id="element-19" data-mp="1w2tzgzckd067" />} data-id="element-18" data-mp="1w3luo9290vvy" />
            <Route path="obvestila" element={<MemberAnnouncements data-id="element-21" data-mp="1i4ccx4ye9tpv" />} data-id="element-20" data-mp="1i3kukvtt5shj" />
            <Route path="obvestila/:id" element={<MemberAnnouncementDetail data-id="element-23" data-mp="1m4wb8bupf3dl" />} data-id="element-22" data-mp="1i3b4774upjbb" />
            <Route path="gradiva" element={<MemberMaterials data-id="element-25" data-mp="1m791dcam8k1q" />} data-id="element-24" data-mp="1m3uwnxehbyr4" />
            <Route path="koledar" element={<Navigate to="/clan/dogodki" replace data-id="element-27" data-mp="6nmguenoqi9z" />} data-id="element-26" data-mp="6nw805kguvh9" />
            <Route path="profil" element={<MemberProfile data-id="element-29" data-mp="ar29z10jq0hx" />} data-id="element-28" data-mp="apr6l2b0iurc" />
          </Route>

          <Route path="/admin" element={<Zascita data-id="element-31" data-mp="qyqavo0wi78c">
                <AdminLayout data-id="element-32" data-mp="qz8gvcdd7ztg" />
              </Zascita>} data-id="element-30" data-mp="ano77rnyzp9y">
            <Route index element={<AdminDashboard data-id="element-34" data-mp="m4cepjeezw2m" />} data-id="element-33" data-mp="m4uj53b8dglm" />
            <Route path="clani" element={<AdminMembers data-id="element-36" data-mp="h8414afv8axk" />} data-id="element-35" data-mp="h6sxcamf736g" />
            <Route path="clani/:id" element={<AdminMemberDetail data-id="element-38" data-mp="c8izfs9b9oh5" />} data-id="element-37" data-mp="h59imogex06s" />
            <Route path="dogodki" element={<AdminEvents data-id="element-40" data-mp="c66dl40fmtyt" />} data-id="element-39" data-mp="c9kc215z6j0z" />
            <Route path="dogodki/nov" element={<AdminEventForm data-id="element-42" data-mp="19uou1fbzov38" />} data-id="element-41" data-mp="19vrlpph4z1k7" />
            <Route path="dogodki/:id" element={<AdminEventDetail data-id="element-44" data-mp="14wey32ifxqgk" />} data-id="element-43" data-mp="19tx4om8zjtle" />
            <Route path="dogodki/:id/uredi" element={<AdminEventForm data-id="element-46" data-mp="zxtvwxjmowph" />} data-id="element-45" data-mp="14xg8r5vjoaxr" />
            <Route path="prisotnost" element={<AdminAttendanceIndex data-id="element-48" data-mp="zw0mxbljm0eb" />} data-id="element-47" data-mp="zx2agfjqwfcx" />
            <Route path="prisotnost/:id" element={<AdminAttendanceTake data-id="element-50" data-mp="vvgq694vsysp" />} data-id="element-49" data-mp="vwidpd333drb" />
            <Route path="porocilo" element={<AdminAttendanceReport data-id="element-52" data-mp="3koklfdxfr2zd" />} data-id="element-51" data-mp="vyl25sol8ytx" />
            <Route path="clanarine" element={<AdminFees data-id="element-54" data-mp="3klq2xrxzfs8l" />} data-id="element-53" data-mp="3kpm7edfzp9vv" />
            <Route path="obvestila" element={<AdminAnnouncements data-id="element-56" data-mp="3gkwcaqt5nzc0" />} data-id="element-55" data-mp="3gly07vv9sgb5" />
            <Route path="obvestila/novo" element={<AdminAnnouncementForm data-id="element-58" data-mp="1w582n3e42yv6" />} data-id="element-57" data-mp="3gotvfcfqgqvw" />
            <Route path="obvestila/:id/branost" element={<AdminAnnouncementReads data-id="element-60" data-mp="205ijjb3fz9ot" />} data-id="element-59" data-mp="1w69lhu1dcpng" />
            <Route path="gradiva" element={<AdminMaterials data-id="element-62" data-mp="203nylws67hkq" />} data-id="element-61" data-mp="206jr35l91e1s" />
            <Route path="koledar" element={<AdminCalendar data-id="element-64" data-mp="253k1ttt1n4z8" />} data-id="element-63" data-mp="254v2hkr6zwm4" />
            <Route path="nastavitve" element={<AdminSettings data-id="element-66" data-mp="29w3coj0cjm0c" />} data-id="element-65" data-mp="253abu6800xtj" />
          </Route>

          <Route path="*" element={<Navigate to="/" replace data-id="element-68" data-mp="2euwpsabq1azz" />} data-id="element-67" data-mp="29xwnmahzsse5" />
        </Routes>
      </BrowserRouter>
    </AppProvider>;
}